import { Entitlement } from '../../types/types'
import { formatDate, formatSerialPrefix } from '../../utils'
import { RequestUnlock } from './RequestUnlock'
// @ts-ignore
import ComputerIcon from '../../public/desktop.svg'
import { Col, Container, Row, Image } from 'react-bootstrap'

type EntitlementListProps = {
  entitlements: Entitlement[]
  handleUnlockRequest: (hwId: string) => Promise<void>
}

const EntitlementList = ({
  entitlements,
  handleUnlockRequest,
}: EntitlementListProps) => (
  <Container>
    {entitlements.map(
      ({
        hardwareId,
        computerName,
        expiryDate,
        isUnlockRequested,
        serialPrefix,
      }) => (
        <Row key={hardwareId} className="align-items-center mb-20">
          <Col sm="3" md="2" className="mb-20 mb-md-0">
            <Image
              className="border-0 img-fluid mx-auto "
              src={ComputerIcon.src}
              alt="computer icon"
            />
          </Col>
          <Col sm="9" md="6" className="mb-20 mb-md-0">
            <div>
              <div>
                <b>{computerName}</b>
              </div>
              <div>
                <i>{formatSerialPrefix(serialPrefix)}</i>
              </div>
              <div>
                <small>Expires: {formatDate(expiryDate, true)}</small>
              </div>
            </div>
          </Col>
          <Col md="4">
            <RequestUnlock
              hardwareId={hardwareId}
              isUnlockRequested={isUnlockRequested}
              onClick={handleUnlockRequest}
            />
          </Col>
        </Row>
      )
    )}
  </Container>
)

export default EntitlementList
